module.exports = __webpack_public_path__ + "img/收储贷（个人）.cc909f71.png";